import { render } from "./my-bots.view.vue?vue&type=template&id=61083b8b&scoped=true"
import script from "./my-bots.view.vue?vue&type=script&lang=js"
export * from "./my-bots.view.vue?vue&type=script&lang=js"

import "./my-bots.view.vue?vue&type=style&index=0&id=61083b8b&scoped=true&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61083b8b"]])

export default __exports__